import moment from 'moment';

export function formatDate(date: Date): string {
  return moment.utc(date).toDate().toLocaleString();
}
